import { useCallback, useEffect, useState } from "react";
import { MessageTypes } from "../../components/toast-message/toast-message";

const useOpenToastMessage = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [toastMessageType, setToastMessageType] = useState<MessageTypes>(
    MessageTypes.INFO
  );

  const handleToastMessageType = useCallback((value: MessageTypes) => {
    setToastMessageType(value);
  }, []);

  const handleIsOpen = useCallback((value: boolean) => {
    setIsOpen(value);
  }, []);

  const handleMessage = useCallback((value: string) => {
    setMessage(value);
  }, []);

  const handleToast = useCallback(
    (message: string, type: MessageTypes) => {
      handleMessage(message);
      handleToastMessageType(type);
      handleIsOpen(true);
    },
    [handleMessage, handleIsOpen, handleToastMessageType]
  );

  useEffect(() => {
    let timeId: NodeJS.Timeout;
    if (isOpen) {
      timeId = setTimeout(() => {
        handleIsOpen(false);
      }, 3000);
    }
    return () => {
      clearTimeout(timeId);
    };
  }, [isOpen, handleIsOpen]);

  return {
    isOpen,
    handleIsOpen,
    message,
    handleMessage,
    toastMessageType,
    handleToastMessageType,
    handleToast
  };
};

export default useOpenToastMessage;
